import PeriodDto from './PeriodDto'
import StatusDto from './StatusDto'

/**
 * @member {PeriodDto} endDatePeriod
 * @member {StatusDto|null} initialStatus
 * @member {Boolean} requireUserSign
 * @member {PeriodDto} startDatePeriod
 */
export default class ConfiguredApplicationDto {
  endDatePeriod
  initialStatus
  requireUserSign
  startDatePeriod

  /**
   * @param {PeriodDto} endDatePeriod
   * @param {StatusDto|null} initialStatus
   * @param {Boolean} requireUserSign
   * @param {PeriodDto} startDatePeriod
   */
  constructor({
    endDatePeriod,
    initialStatus,
    requireUserSign,
    startDatePeriod
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    endDatePeriod = new PeriodDto(endDatePeriod ?? {})
    if (initialStatus) {
      initialStatus = new StatusDto(initialStatus)
    }
    requireUserSign = Boolean(requireUserSign ?? false)
    startDatePeriod = new PeriodDto(startDatePeriod ?? {})

    Object.defineProperty(this, 'endDatePeriod', Object.assign({ value: endDatePeriod }, properties))
    Object.defineProperty(this, 'initialStatus', Object.assign({ value: initialStatus }, properties))
    Object.defineProperty(this, 'requireUserSign', Object.assign({ value: requireUserSign }, properties))
    Object.defineProperty(this, 'startDatePeriod', Object.assign({ value: startDatePeriod }, properties))

    Object.freeze(this)
  }
}
